import { callapi } from "./V2_APIHelperFile";
import { AREA, DOWNLOAD_FILE, FILE_TYPE, IRIS_UTTERANCE, MODE, MODE_QUERY, TILE_NAME , SEGMENT, TILE_INFO, SEND_SERVICE_GROUP, DEFAULT_SERVICE_GROUP } from "../../utils/constants";
import { ALLOWED_PARAMETERS } from "../../utils/constants";
import { INCIDENT_TILE_UTTERANCE, SERVICE_NOT_VALID } from "../../utils/constants";
 
const getTilesData = (params, identifyTile, finalTileObject, context) => {
  let shouldDownloadFile = false;
  params.map((e) => {
    let [key, value] = e.split("=");
    identifyTile.push(key.toLowerCase());
    switch (key.toLowerCase()) {
      case "tilename": {
        const decoded = decodeURIComponent(value || "");
        // Normalize non-breaking spaces to regular spaces so backend validation
        // and tile lookups work even if the URL used %C2%A0 instead of %20.
        finalTileObject["TileName"] = decoded.replace(/\u00A0/g, " ");
        return;
      }
      case "irisutterance":
        finalTileObject["IrisUtterance"] = decodeURIComponent(value);
        return;
      case "area":
        finalTileObject["Area"] = decodeURIComponent(value);
        return;
      case "mode":
        finalTileObject["Mode"] = decodeURIComponent(value.toLowerCase());
        return;
      case "downloadfile":
        finalTileObject["downloadfile"] = decodeURIComponent(value.toLowerCase());
        shouldDownloadFile = true;
        return;
      case "typeoffeedback":
        finalTileObject["typeOfFeedback"] = decodeURIComponent(value.toLowerCase());
        shouldDownloadFile = true;
        return;
      case "segment":
        finalTileObject["Segment"] = decodeURIComponent(value);
        return;
      case "tileinfo":
        finalTileObject["tileinfo"] = decodeURIComponent(value);
        return;
      case "sendservicegroup":
        finalTileObject["sendServiceGroup"] = decodeURIComponent(value);
        return;
      case "defaultservicegroup":
        finalTileObject["defaultServiceGroup"] = decodeURIComponent(value);
        return; 
      case "subsegment":
            finalTileObject["SubSegment"] = decodeURIComponent(value);
            return;      
      default:
        return;
    }
  });

  if (shouldDownloadFile) {
    return true; // Do not call the API and return true if downloadfile is present
  }

  let result = callapi(
    context,
    finalTileObject["TileName"],
    finalTileObject["IrisUtterance"],
    finalTileObject["Area"]
  );
  
  return result;
};

 
const checkIncidentTile = (identifyTile, finalTileObject) => {
  if (
    identifyTile.includes(TILE_NAME) &&
    identifyTile.includes(IRIS_UTTERANCE) &&
    identifyTile.includes(MODE) &&
    MODE_QUERY.includes(finalTileObject["Mode"]) &&
    finalTileObject["IrisUtterance"].includes(INCIDENT_TILE_UTTERANCE)
  ) {
    return true;
  } else if (
    identifyTile.includes(TILE_NAME) &&
    identifyTile.includes(MODE) &&
    MODE_QUERY.includes(finalTileObject["Mode"]) &&
    !finalTileObject["Mode"].includes("service request")
  ) {
    finalTileObject["IrisUtterance"] = "";
    return true;
  }
  return false;
};
 
 
 const checkNonAmericaWithIrisUtterance = (identifyTile,finalTileObject)=>{
  if(identifyTile.includes(TILE_NAME) &&
  identifyTile.includes(IRIS_UTTERANCE) &&
  !finalTileObject["IrisUtterance"].includes(INCIDENT_TILE_UTTERANCE))
  {
    return true;
  }else{
    return false;
  }
 }
 
const checkNonAmerica = (identifyTile, finalTileObject) => {

  if (
    checkNonAmericaWithIrisUtterance(identifyTile, finalTileObject) 
    //checkNonAmericaWithoutIrisUtterance(identifyTile, finalTileObject)
  ) {
    return true;
  } else {
    return false;
  }
};
 
const checkAmerica = (identifyTile, finalTileObject) => {
  if (identifyTile.includes(TILE_NAME) && identifyTile.includes(AREA) && !identifyTile.includes(SEGMENT)) {
    return true;
  }
  return false;
};


const checkAmericaSMC = (identifyTile, finalTileObject) => { 
  if (identifyTile.includes(TILE_NAME) && identifyTile.includes(AREA) && identifyTile.includes(SEGMENT)) {
    return true;
  }
  return false;
};

const checkFeedbackUrlDownload = (identifyTile, finalTileObject) => {
  if (identifyTile.includes(DOWNLOAD_FILE) || identifyTile.includes(FILE_TYPE)) {
    return true;
  }
  return false;
};

// TileName-only P-URLs (e.g. ?TileName=ECIF+Support+Services+M365) are valid deep-links
// that should route through the NonAmerica path for auto-pin and tile resolution.
const checkTileNameOnly = (identifyTile) => {
  const filtered = identifyTile.filter(Boolean);
  return filtered.length === 1 && filtered.includes(TILE_NAME);
};

const getTileFinalScenario = (identifyTile, finalTileObject) => {
  if (checkIncidentTile(identifyTile, finalTileObject)) {
    finalTileObject["isIncidentTile"] = true;
  } else if (checkAmerica(identifyTile, finalTileObject)) {
    finalTileObject["isAmerica"] = true;
  } else if (checkNonAmerica(identifyTile, finalTileObject)) {
    finalTileObject["isNonAmerica"] = true;
    if( finalTileObject["tileinfo"] == "true"){
      finalTileObject["tileinfo"] = true;
    }
  } else if (checkAmericaSMC(identifyTile, finalTileObject)) {
    finalTileObject["isAmericaSMC"] = true;
  }
  else if(checkFeedbackUrlDownload(identifyTile, finalTileObject)){
      finalTileObject["isFeedbackUrlDownload"] = true;
  }
  else if (checkTileNameOnly(identifyTile)) {
    // TileName-only P-URLs route through NonAmerica path for auto-pin resolution
    finalTileObject["isNonAmerica"] = true;
  }
  else {
    finalTileObject["Error"] = SERVICE_NOT_VALID;
  }
  if( finalTileObject["sendservicegroup"] == "true"){
    finalTileObject["sendservicegroup"] = true;
  }
};
 
const validateParameter = (identifyTile) => {
  for (let param of identifyTile) {
    if (!ALLOWED_PARAMETERS.includes(param)) {
      return false;
    }
  }
  return true;
};
 
export const GetTheTileConfiguration = async (
  finalTileObject: any,
  context: any
) => {
  const query = window.location.search;
 
  if (query === "") {
    return "";
  } else {
    const params = query.slice(1).split("&");
    let identifyTile = [];
    let result = await getTilesData(
      params,
      identifyTile,
      finalTileObject,
      context
    );
    if (validateParameter(identifyTile) && result === true) {
      getTileFinalScenario(identifyTile, finalTileObject);
      finalTileObject["isValidated"] = true;
      return finalTileObject;
    } else if (validateParameter(identifyTile) && identifyTile.includes("tilename")) {
      // ValidateParameters API may return false for partial name matches
      // (e.g. URL has "DWR" but catalog has "DWR Help"). Allow the flow to proceed
      // — startTileFlowBasedOnSrc() uses includes() matching to find the tile in workspace,
      // and the auto-pin logic handles tiles not yet in workspace.
      getTileFinalScenario(identifyTile, finalTileObject);
      finalTileObject["isValidated"] = true;
      return finalTileObject;
    } else {
      finalTileObject["Error"] = SERVICE_NOT_VALID;
      return finalTileObject;
    }
  }
};

